import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {SimpleLabel} from '@techsee/techsee-ui-common/lib/forms/labels/simple';
import {GuidenceProgressItem} from '../guidance-progress/GuidanceProgress';

import './styles.scss';
import {
    BorderRoundedIcon,
    IconAnimation,
    IconAnimations,
    IconColor,
    IconSize,
    IconSizes
} from '@techsee/techsee-ui-common/lib/icons/large-rounded-icon';

export interface ProgressListProps {
    progressList: GuidenceProgressItem[];
    renderActions?: (label: string) => React.ReactNode;
}

export class ProgressList extends TechseeBaseComponent<ProgressListProps> {
    renderInternal() {
        const {progressList, renderActions} = this.props;

        return (
            <div className={'progress-list'}>
                {progressList.map((item: GuidenceProgressItem, index: number) => {
                    const itemClasses = 'progress-list-item' + (item.isActive ? ' active' : '');

                    return (
                        <React.Fragment key={index}>
                            <div className={`${itemClasses} ${item.classNameItem}`}>
                                <BorderRoundedIcon
                                    iconName={item.icon}
                                    colorName={item.iconColor as IconColor}
                                    sizeName={item.iconSize || (IconSizes.Medium as IconSize)}
                                    noBorder={item.iconNoBorder}
                                    animation={
                                        (item.isIconAnimated
                                            ? IconAnimations.Rotate
                                            : IconAnimations.None) as IconAnimation
                                    }
                                />
                                <SimpleLabel className={item.classNameLabel}>{item.label}</SimpleLabel>
                                {renderActions && (
                                    <div className={'progress-list-action'}>{renderActions(item.label)}</div>
                                )}
                            </div>
                            {item.subLabel && <div className={'progress-list-item-sub-label'}>{item.subLabel}</div>}
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
}
